module.exports = __webpack_public_path__ + "static/img/escort.2404663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialist/escort.png
// module id = Donf
// module chunks = 1